import { makeStyles } from "@material-ui/core";
import { Grid, Button, Typography } from "@material-ui/core";
import { history } from "../../../../helpers/history";
import { routePaths } from "../../../config/route-paths";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    buttonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.hover,
        },
        borderRadius: 29,
        minWidth: "25%",
        backgroundColor: theme.palette.ePrimary.base,
        color: theme.palette.eWhite.base,
        textTransform: "capitalize",
        fontSize:"0.75rem"
    },
    skeleton: {
        background: theme.palette.eBackground.base
    }
}));
export default function TrackingNewConnection() {
    const classes = useStyles();
    const {t: labels, ready: labelReady} = useTranslation("label-E_TRACKING_NEW_CONNECTION");
    const [enable, setEnable] = useState(false);
    let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp);
    
    useEffect(() => {
        widgets &&
            widgets.map((item) => {
                if (item?.widgetCode === "E_TRACKING_NEW_CONNECTION") {
                    setEnable(item?.widgetDefaultValue);
                }
            });
    }, [widgets]);

    let buttonHandler = () => history.push(routePaths.TRACK_REQUEST);
    
    return (
        <>
            { enable && labelReady ? (
                <Grid container>
                    <Grid item>
                        <Button
                            variant="contained"
                            className={classes.buttonStyle}
                            onClick={buttonHandler}
                        >
                            {labels("E_TRACKING_BUTTON")}
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <Skeleton variant="rect" animation="pulse" height="2.813rem" />
            )}
        </>
    );
}
